import { useStore } from "@/store";
import { observer } from "mobx-react";
import React from "react";
import { OrderDetailsEmergentPanel } from "./OrderDetailsEmergent";
import { OrderDetailsOntario } from "./OrderDetailsOntario";
import { OrderDetailsBasePanel } from "./OrderDetailsBase";
import { api } from "@/api";
import type { GetProductCategoriesDto } from "@/api/types";
import { useEffectOnce } from "usehooks-ts";

export const OrderDetailsPanel = observer(() => {
  const {
    activeProvinceFullName,
    setProductCategories,
    orderData,
    isEmergentFlow,
    isOntarioFlow,
    ga4Store,
  } = useStore();

  useEffectOnce(() => {
    const data: GetProductCategoriesDto = {
      ada: orderData.ada,
      province: activeProvinceFullName,
    };

    api.getProductCategories(data).then((data) => {
      setProductCategories(data);
      ga4Store.viewItems();
    });
  });

  if (isOntarioFlow) return <OrderDetailsOntario />;

  if (isEmergentFlow) return <OrderDetailsEmergentPanel />;

  return <OrderDetailsBasePanel />;
});
